(() => {
  function initializeSubscriptionThankYou() {
    let hasOpenedPopup = false;

    document.querySelectorAll('[data-subscription-thank-you]').forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;
      const successMessage = dialog.closest('form')?.querySelector('[data-subscription-success]');
      const closeButtons = dialog.querySelectorAll('[data-subscription-thank-you-close]');
      closeButtons.forEach((button) => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (successMessage instanceof HTMLElement) successMessage.focus();
      });
      if (!hasOpenedPopup && !dialog.open) {
        dialog.showModal();
        hasOpenedPopup = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSubscriptionThankYou);
  } else {
    initializeSubscriptionThankYou();
  }
})();
